export default __webpack_public_path__ + "static/tour_04_learning_goals-2933b5032bba7d9beec35607453f95dd.jpg";